import styles from './Price.module.scss';

type Props = {
  price?: number;
  className?: string;
};

export const Price = ({price = 0, className}: Props) => {
  const integer = Math.trunc((price ?? 0) / 100);
  const decimal = Math.trunc((price ?? 0) % 100);

  const decimalString =
    decimal > 9 ? decimal : String(decimal).padStart(2, '0');

  return (
    <span
      itemProp="offers"
      itemScope
      itemType="https://schema.org/Offer"
      className={styles.root}
    >
      <meta itemProp="price" content={`${price / 100}`} />
      {price > 0 && (
        <span className={className}>
          <span className="visually-hidden">Цена:&nbsp;</span>
          {integer},{decimalString} &#8381;
        </span>
      )}
      <meta itemProp="priceCurrency" content="RUB" />
    </span>
  );
};
